module.exports = __webpack_public_path__ + "static/media/undraw_artificial-intelligence_43qa.d444220a.svg";